import {
  DataGridProProps,
  FilterColumnsArgs,
  GetColumnForNewFilterArgs,
} from "@mui/x-data-grid-pro";
import { DataGrid7 } from "./DataGrid7";
import { format, parseISO } from "date-fns";
import { Box, useGridApiRef7 } from "../../platform-style";
import { useContext, useState } from "react";
import { WorkspaceContext } from "../Workspace/Workspace";

interface DataGridLegacyProps extends DataGridProProps {
  components?: any;
  componentsProps?: any;
  headerHeight?: any;
  disableSelectionOnClick?: any;
  page?: any;
  pageSize?: any;
  onPageChange?: any;
  onPageSizeChange?: any;
  rowsPerPageOptions?: any;
  selectionModel?: any;
  onSelectionModelChange?: any;
  disableMultipleSelection?: any;
  showCellRightBorder?: any;
  showColumnRightBorder?: any;
}

/**
 * @deprecated Use DataGrid7 instead.
 */
export const DataGrid = (props: DataGridLegacyProps) => {
  const internalApiRef = useGridApiRef7();
  const apiRef = props.apiRef ? props.apiRef : internalApiRef;
  const [key, setKey] = useState(0);
  const [filterModel, setFilterModel] = useState(props.filterModel);

  const [pageModel, setPageModel] = useState(
    props.page || props.pageSize
      ? {
          page: props.page ? props.page : 0,
          pageSize: props.pageSize ? props.pageSize : 0,
        }
      : undefined
  );

  // @ts-ignore
  function handlePageModelChange({ page, pageSize }) {
    if (props.onPageChange) {
      props.onPageChange(page);
    }
    if (props.onPageSizeChange) {
      props.onPageSizeChange(pageSize);
    }
    setPageModel({ page: page, pageSize: pageSize });
  }

  const newColumns: any[] = [];

  props.columns.forEach((legacyColumn) => {
    let newColumn = {
      ...legacyColumn,
      valueGetter:
        typeof legacyColumn.valueGetter === "function"
          ? (value: any, row: any) => {
              // @ts-ignore
              return legacyColumn.valueGetter({ value: value, row: row });
            }
          : undefined,
      valueFormatter:
        typeof legacyColumn.valueFormatter === "function"
          ? (value: any, row: any, _column: any, _apiRef: any) => {
              // @ts-ignore
              return legacyColumn.valueFormatter({ value: value, row: row });
            }
          : undefined,
    };
    if (legacyColumn.type === "date") {
      newColumn.valueGetter = (value) => {
        if (value instanceof Date) {
          return value;
        }
        return value && parseISO(value);
      };
      if (legacyColumn.renderCell) {
        newColumn.renderCell = (params) => {
          // @ts-ignore
          return params.value && format(params.value, "M/d/yyyy");
        };
      }
      if (legacyColumn.valueFormatter) {
        newColumn.valueFormatter = (value, _row, _column, _apiRef) => {
          return format(value, "M/d/yyyy");
        };
      }
    }
    if (legacyColumn.editable === true) {
      newColumn.minWidth = 240;
    }
    newColumns.push(newColumn);
  });

  const filterColumns = ({ field, columns, currentFilters }: FilterColumnsArgs) => {
    const filteredFields = currentFilters?.map((item) => item.field);
    return columns
      .filter(
        (colDef) =>
          colDef.filterable && (colDef.field === field || !filteredFields.includes(colDef.field))
      )
      .map((column) => column.field);
  };

  const getColumnForNewFilter = ({ currentFilters, columns }: GetColumnForNewFilterArgs) => {
    const filteredFields = currentFilters?.map(({ field }) => field);
    const columnForNewFilter = columns
      .filter((colDef) => colDef.filterable && !filteredFields.includes(colDef.field))
      .find((colDef) => colDef.filterOperators?.length);
    return columnForNewFilter?.field ?? null;
  };

  const isInWorkspace = useContext(WorkspaceContext);

  return (
    <Box display={"grid"} height={isInWorkspace ? "calc(100% - 67px)" : "100%"} width={"100%"}>
      <DataGrid7
        {...props}
        key={key}
        sx={{ ...props.sx, minHeight: "400px" }}
        columns={newColumns}
        rowSelectionModel={props.selectionModel}
        onRowSelectionModelChange={props.onSelectionModelChange}
        disableMultipleRowSelection={props.disableMultipleSelection}
        disableRowSelectionOnClick={props.disableSelectionOnClick}
        showCellVerticalBorder={props.showCellRightBorder}
        showColumnVerticalBorder={props.showColumnRightBorder}
        columnHeaderHeight={props.headerHeight !== undefined ? props.headerHeight : 56}
        onPreferencePanelClose={(params, event, details) => {
          setKey((prev) => prev + 1);
          if (props.onPreferencePanelClose) {
            props.onPreferencePanelClose(params, event, details);
          }
        }}
        slots={{
          toolbar: props.components.Toolbar ? props.components.Toolbar : undefined,
          noRowsOverlay: props.components.NoRowsOverlay
            ? props.components.NoRowsOverlay
            : undefined,
        }}
        slotProps={{
          ...props.componentsProps,
          filterPanel: {
            filterFormProps: {
              filterColumns,
            },
            getColumnForNewFilter,
            logicOperators: ["and"],
            disableRemoveAllButton: true,
          },
        }}
        onFilterModelChange={
          props.onFilterModelChange
            ? (model, details) => {
                setFilterModel(model);
                const newItems = model.items.map((filter) => {
                  return {
                    id: filter.id,
                    // @ts-ignore
                    value: filter.value,
                    // @ts-ignore
                    operatorValue: filter.operator,
                    // @ts-ignore
                    columnField: filter.field,
                  };
                });
                // @ts-ignore
                return props.onFilterModelChange({ ...model, items: newItems }, details);
              }
            : (model) => setFilterModel(model)
        }
        filterModel={filterModel}
        paginationModel={pageModel}
        onPaginationModelChange={pageModel ? handlePageModelChange : undefined}
        pageSizeOptions={props.rowsPerPageOptions}
        // @ts-ignore
        apiRef={apiRef}
      />
    </Box>
  );
};
